import React from 'react';
import { Card, CardContent, CardHeader, Grid } from '@mui/material';
import { useParams } from 'react-router-dom';
import DatacorLogoSpinner from '../../../components/datacorLogoSpinner/DatacorLogoSpinner';
import useGhsPrecautionaryPhraseContainer from './hooks/useGhsPrecautionaryPhraseContainer';
import GhsPrecautionaryPhraseGrid from './grid/GhsPrecautionaryPhraseGrid';
import GhsPrecautionaryPhraseFormContainer from './form/GhsPrecautionaryPhraseFormContainer';
import TranslatableText from '../../../components/i18n/TranslatableText';
import { GhsPrecautionaryPhrasesGridDefs } from '../../../constants/i18n/translations/termDefinitions/formulation';

type ParamTypes = { phraseId: string };

export interface GhsPrecautionaryPhraseContainerProps {
    showForm: boolean;
}

const GhsPrecautionaryPhraseContainer = ({
    showForm,
}: GhsPrecautionaryPhraseContainerProps) => {
    const { phraseId } = useParams<ParamTypes>();

    const {
        handleSetPhraseList,
        handleSetIsFormDirty,
        handlePromptFormDirty,
        languagesList,
        defaultLangId,
        phraseIdList,
        isLoadingLanguages,
        canViewGhsPrecautionaryPhrase,
        termSet,
    } = useGhsPrecautionaryPhraseContainer(phraseId);

    return (
        <>
            {isLoadingLanguages ? (
                <DatacorLogoSpinner />
            ) : canViewGhsPrecautionaryPhrase ? (
                <Card sx={{ minHeight: '850px' }}>
                    <CardContent sx={{ minHeight: '850px', padding: '0' }}>
                        <CardHeader
                            title={
                                (
                                    <TranslatableText
                                        termSet={termSet}
                                        termKey={
                                            GhsPrecautionaryPhrasesGridDefs.Precautionary_Phrases
                                        }
                                    />
                                ) as unknown as string
                            }
                        />
                        <Grid
                            container
                            spacing={1}
                            minHeight={'850px'}
                            paddingLeft={'1em'}
                            paddingRight={'1em'}
                            paddingBottom={'4em'}>
                            <Grid item xs={12} xl={6} minHeight={'425px'}>
                                <GhsPrecautionaryPhraseGrid
                                    handleSetPhraseList={handleSetPhraseList}
                                    defaultLanguageId={defaultLangId}
                                    currentPhraseId={phraseId}
                                    handlePromptFormDirty={
                                        handlePromptFormDirty
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} xl={6} minHeight={'425px'}>
                                {!showForm || !defaultLangId ? (
                                    <></>
                                ) : (
                                    <GhsPrecautionaryPhraseFormContainer
                                        phraseId={phraseId}
                                        defaultLangId={defaultLangId}
                                        languageList={languagesList}
                                        phraseIdList={phraseIdList}
                                        handleSetIsFormDirty={
                                            handleSetIsFormDirty
                                        }
                                        handlePromptFormDirty={
                                            handlePromptFormDirty
                                        }
                                    />
                                )}
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            ) : (
                <Card sx={{ height: '100%' }}></Card>
            )}
        </>
    );
};

export default GhsPrecautionaryPhraseContainer;
